<template>
  <v-dialog v-model="dialog" width="700px">
    <v-card v-if="ready === true">
      <p class=".title ma-2">Option   Expire / Extend</p>
      <v-form ref="huovExpExt" v-model="huovExpExtValid">
        <v-row no-gutters>
          <v-col cols="3" class="px-1">
            
            <v-menu
              v-model="huovVVDatmenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="huov.huov_vv_dat" 
              label="Expire date"
              v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker v-model="huov.huov_vv_dat2" :first-day-of-week="1" @input="huov.huov_vv_dat = $moment(huov.huov_vv_dat2).format('DD-MM-YYYY'); huovVVDatmenu = false"></v-date-picker>
            </v-menu>  
          </v-col>
          <v-col cols="2" class="px-1">
           <v-select v-model="huov.huov_vv_tijd" :items="huov_vv_tijdKeuzes" menu-props="auto" item-value="huov_vv_tijd" item-text="huov_vv_tijdTijd" label="Expire time"></v-select>
          </v-col> 
        </v-row>


      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary mx-2"
          small
          @click="updExpExt('bkn')"
          :disabled="!huovExpExtValid"
          >Book</v-btn
        >
        <v-btn
          color="primary mx-2"
          small
          @click="updExpExt('exp')"
          :disabled="!huovExpExtValid"
          >Expire</v-btn
        >
        <v-btn
          color="primary mx-2"
          small
          @click="updExpExt('ext')"
          :disabled="!huovExpExtValid"
          >Extend</v-btn
        >
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      huovExpExtValid: false,
      ready: false,
      huovVVDatmenu: false,
      huov_vv_tijdKeuzes: [],
      huov: {}
    }
  },
  methods: {
    open(huov_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getHuovExpExt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovExpExt",
          },
          getHuovExpExt: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovExpExt;
            res.data.getHuovExpExt.huov_vv_tijdKeuzes.forEach(function (vv_tijd) {
              deze.huov_vv_tijdKeuzes.push(vv_tijd);
            });
            this.ready = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updExpExt(expExt) {
      this.$axios
        .post("ares/json/ares/huov/updExpExt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updExpExt",
          },
          updExpExt: {
            huov_encrid: this.huov.huov_encrid,
            huov_exp_ext: expExt,
            huov_vv_dat: this.huov.huov_vv_dat,
            huov_vv_tijd: this.huov.huov_vv_tijd
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.updExpExt.text,
              color: res.data.updExpExt.color,
            });
            if (res.data.updExpExt.color == "success" || res.data.updExpExt.color == "warning" ) {
              setTimeout(() => { this.$router.reload("/huov/onHuov/" + res.data.updExpExt.huov_encrid); }, 1000); 
            }
            this.dialog = false;
          }
        });
    },
  }
  
};
</script>

